import React from 'react';
import { Typography, Grid, makeStyles } from '@material-ui/core';
import { moneyFormat } from 'design-system';

const { formatMoney } = moneyFormat;

type PriceInformationProps = {
  total: number;
  numberOfPayments: number;
  currency: string;
};

const useStyles = makeStyles({
  priceContainer: {
    textAlign: 'center',
  },
  priceText: {
    fontSize: 23,
    fontWeight: 900,
  },
  labelText: {
    fontSize: 13,
    fontWeight: 500,
  },
});

const PriceInformation = ({
  total,
  numberOfPayments,
  currency,
}: PriceInformationProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid container item data-testid="price-information">
      <Grid item xs={6} className={classes.priceContainer}>
        <Typography
          className={classes.labelText}
          data-testid="number-payments-text"
        >{`${numberOfPayments} Cuotas`}</Typography>
        <Typography className={classes.priceText} data-testid="month-payment">
          {formatMoney(total / numberOfPayments, false, currency)}
        </Typography>
        <Typography className={classes.labelText}>mensual</Typography>
      </Grid>
      <Grid item xs={6} className={classes.priceContainer}>
        <Typography className={classes.labelText}>Total</Typography>
        <Typography className={classes.priceText} data-testid="total-payment">
          {formatMoney(total, false, currency)}
        </Typography>
        <Typography className={classes.labelText}>anual</Typography>
      </Grid>
    </Grid>
  );
};

export default PriceInformation;
